


















































































































import { Component, Vue } from "vue-property-decorator";
import "@/styles/MCQ.scss";
import { GeneralService } from "../services/general-service";
import AuthService from "../services/auth-service";
import config from "../services/api-config";
import moment from "moment";
import router from "../router";
import store from "../store";

@Component({
  components: {},
})
export default class PastPapers extends Vue {
  private service = new GeneralService();
  private auth = new AuthService();
  private view = 1;
  private selected: any = null;
  private text = "";
  private history: any = [];
  private classSection = "";
  private sending = false;
  private currentPage = 1;

  private teacherData = [];

  private refreshHistory() {
    this.service.getStudentChat(this.auth.session.userName.split("@")[0]).then((response) => {
      this.history = response.data;
    });
  }

  private formatDate(date) {
    return moment(date).format('Do MMM, YYYY')
  }


  sendData() {
    let data = {
      device_Id: this.auth.session.userName.split("@")[0] + window.navigator.userAgent.replace(/\D+/g, ''),
      application_Version: "1.4.8",
      Student_ID: this.auth.session.userName.split("@")[0],
      Teacher_ID: this.selected.teacher_ID,
      Question: this.text,
      userMacAddress: "dsdd",
      Subject_ID: this.selected.subject_ID,
      Section_ID: this.classSection,
      From: this.selected.teacher_Name,
      Topic: null,
      application_Name: "PGC",
    };

    if (this.sending == false){
      this.sending = true;
      this.service.sendQuestion(data, false).then(response => {
      this.sending = false;
      if (response.message.messageTypeId == 'Success'){
        this.selected = null;
        this.text = '';
        this.view = 2;
        this.refreshHistory();
      } else {
        alert('Your question could not be asked at this time. Please try again later');
        throw(response.message.messageTypeId);
      }
    });
    }

    
  }

  mounted() {
    this.service
      .getInfoEMS(this.auth.session.userName.split("@")[0])
      .then((result) => {
        this.classSection = result.data[0].Class_section_id;
      });

    this.service
      .getTeacherSubject(
        this.auth.session.userName.split("@")[0],
        localStorage[config.deviceId]
      )
      .then((result) => {
        this.teacherData = result.data.Data;

      });
  }
}
